export const isTurboEnabled = (hideTurboCheckoutOption = false): boolean => {
    // Turbo is now supported for accessibility (TalkBack/VoiceOver) users, so we no longer
    // gate it behind the `accessibility-enabled` header. The widget is keyboard and
    // screen-reader operable.
    return !hideTurboCheckoutOption;
};
